_ = require('lodash')
moment = require('moment')
$ = require('jquery')

GroupListMembersCtrl = ($scope ,$translate ,groupInfo ,userInfo ,GroupMemberService ) ->
  angular.element(document.body).css 'min-width', 0

  $(document).ready( ->
    document.body.scrollTop = document.documentElement.scrollTop = 0
  )
  $scope.groupInfo = groupInfo
  $scope.userInfo = userInfo
  pageSize = 10
  $scope.listMember = []
  $scope.currentPage = 0
  $scope.isLoading = false
  $scope.isSubmitting = false
  $scope.noResults = true
  $scope.totalPages = 0

  $scope.loadMore = ->
    $scope.isLoading = true
    $scope.currentPage++
    params =
      id : groupInfo.id
      page_size : pageSize
      page : $scope.currentPage
    GroupMemberService.listMembers(params)
    .then (data) ->
      $scope.listMember = _.union($scope.listMember , data.members )
      $scope.totalPages = data.total_pages
      $scope.noResults = $scope.listMember.length == 0
    .finally ->
      $scope.isLoading = false

  $scope.hasMore = ->
    $scope.noResults == false && $scope.currentPage < $scope.totalPages

  $scope.loadMore()

GroupListMembersCtrl.$inject = [
  '$scope'
  '$translate'
  'groupInfo'
  'userInfo'
  'GroupMemberService'
]

module.exports = GroupListMembersCtrl



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/group-member/group-list-member-controller.coffee